import type { ComponentProps } from "react";

type Props = {
  onClick: ComponentProps<"button">["onClick"];
};

export default function RemoveButton({ onClick }: Props) {
  return (
    <button
      aria-label="remove from cart"
      className="block cursor-pointer border-0 bg-transparent underline leading-none py-1"
      data-testid="remove-button"
      onClick={onClick}
      title="remove from cart"
    >
      remove
    </button>
  );
}
